import { ThemeProvider } from '@mui/system';
import { FC, PropsWithChildren } from 'react';

import { useSystemTheme } from '@vp/common/ui/hook/useSystemTheme';

export const VpSystemThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const systemTheme = useSystemTheme();
  return <ThemeProvider theme={systemTheme}>{children}</ThemeProvider>;
};
